import { useState } from 'react'
import { Icon } from '@iconify/react'
import { Button, useGlobalState } from '@pepper/ui'
import { useModal } from '@ebay/nice-modal-react'

import CreateContentPopover from 'components/CreateContentPopover'

import s from './EmptyList.module.css'

type Props = {
  project?: Project
}

const EmptyList = ({ project }: Props) => {
  const { permissions } = useGlobalState()
  const [showCreateContentPopover, setShowCreateContentPopover] =
    useState(false)
  const { show: showServiceSelectionDrawer } = useModal(
    'service-selection-drawer'
  )
  const { show: showUpsellBanner } = useModal('buy-cmp')
  const hasCMPAccess = permissions?.cmp

  const handleCreateContent = () => {
    if (!hasCMPAccess) {
      showUpsellBanner()
    } else {
      setShowCreateContentPopover(true)
    }
  }

  const handleOrderContent = () => {
    showServiceSelectionDrawer({
      projectId: project?.id,
      projectBody: {
        project_title: project?.project_title,
      },
    })
  }

  return (
    <div className={s.wrapper}>
      <h4 className={s.title}>Let&apos;s add something here!</h4>
      <p className={s.subtitle}>
        You&apos;ve just created a new Project. Create content yourself using
        our AI powered
        <br /> PepperDocs or create an order to let our marketplace experts do
        the work for you.
      </p>
      <div className={s.actions}>
        <Button type="primary" onClick={handleCreateContent}>
          <Icon icon="memory:plus" width={14} height={14} />
          Create Content
        </Button>
        <Button type="ghost" onClick={handleOrderContent}>
          Order Content From Experts
        </Button>
      </div>
      <CreateContentPopover
        showCreateContentPopover={showCreateContentPopover}
        setShowCreateContentPopover={setShowCreateContentPopover}
      />
    </div>
  )
}

export default EmptyList
